module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAABV0lEQVQ4T6WTPU7DQBCFZzbeiDIlJTfAPY07CprQUSDhG0CKeJUunb3rIpGQqMMFkLmBwwXIEXIDoPXPDpoojpzEIiux1Wp/vnlv5y2maRpYa+eI+A2OQ0o5HI1Gm/NojMnbC6cYxpiQiAZKqfkOEEVRcOpis79VHCilpnsAJgPAw18gKeVtVVW+tfYY8G8FrgBjjE9EwyMLWushIj4egoho2RzuKrLpgusjxnF84Xneped5y702ugCavABAhoihlNJnyE7B1sJTW2Zd1+FkMlnzmtZ6KoTIx+NxznMAWCmlMmcLXICI7oUQzwDwUtf1DcOdAbPZbFAUxScRvSMi58DvChKHaW8076O1XrB/ls0WEHEdRdHCSUGSJHdCiBgRGQJEdEZEYVVV16i1XvX7/aBpy6ECbl2v1/uw1r61fywingPAFba+81dHUF6llFlZlhkX7tj/+QWrXtiNmNirlwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/review.png
// module id = 824
// module chunks = 110